import { render, staticRenderFns } from "./EditLocation.vue?vue&type=template&id=354b320c&scoped=true"
import script from "./EditLocation.vue?vue&type=script&lang=js"
export * from "./EditLocation.vue?vue&type=script&lang=js"
import style0 from "./EditLocation.vue?vue&type=style&index=0&id=354b320c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b320c",
  null
  
)

export default component.exports